import { Box, Drawer as JoyDrawer, drawerClasses, styled, Typography } from '@mui/joy';

import { LEFT_MENU_WIDTH } from 'theme/constants';

interface IProps {
  autoWidth?: boolean;
  fullScreen?: boolean;
}

// Full-bleed rows (header, footer) cancel this padding with negative margins.
export const DRAWER_GUTTER = '24px';

const propsToSkip: PropertyKey[] = ['autoWidth', 'fullScreen'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

export const Drawer = styled(JoyDrawer, { shouldForwardProp })<IProps>(
  ({ autoWidth, fullScreen }) => ({
    [`.${drawerClasses.content}`]: {
      maxWidth: `calc(100vw - var(--custom-leftMenuWidth, ${LEFT_MENU_WIDTH}px))`,
      padding: `var(--custom-drawerContentPadding, 0 ${DRAWER_GUTTER})`,

      ...(autoWidth && {
        width: 'auto',
      }),

      ...(fullScreen && {
        width: '100vw',
        maxWidth: '100vw',
      }),
    },
  })
);

export const Title = styled(Typography)({
  fontWeight: 500,
  flex: 1,
  minWidth: 0,
});

export const Content = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  gap: '24px',
  flex: 1,
  // Allow flex shrinking so tall children don't push Content past the drawer.
  minHeight: 0,
});
